import { QRCodeData } from "@/types/qrCode";
import { SafeImageSrc } from "@/utils/helpers";
import { Box, Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import MiniLoader from "../MiniLoader";


export const QrCodeTemplateItem: React.FC<QRCodeData> = ({ image_b64, device_id }) => {
    return (
        <Grid>
            <img
                alt={`QR code for device ${device_id}`}
                src={SafeImageSrc(`data:image/png;base64,${image_b64}`)}
                style={{
                    maxWidth: '100%',
                    height: 'auto',
                }}
            />
        </Grid>
    )
}
export const QRCodeTemplateData = ({ qrCodes, loading, error }: { qrCodes: QRCodeData[], loading: boolean, error: string | null }) => {
    const { t } = useTranslation();
    if (loading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '400px',
                }}
            >
                <MiniLoader size={40} />
                <Typography variant="h4">
                    {t('qrCodeLoading', 'Fetching QR code ...')}
                </Typography>
            </Box>
        );
    }
    if (error) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '400px',
                }}
            >
                <Typography variant="h6" color="textSecondary">
                    {error}
                </Typography>
            </Box>
        );
    }
    if (qrCodes.length === 0) {
        return (
            <Box py={6} textAlign="center">
                <Typography variant="h6" color="textSecondary">
                    {t('qrCodeNotFound', 'No QR codes found.')}
                </Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ p: 3, pt:6 }}>
            <Grid container spacing={3}>
                {qrCodes.map((qr, index) => (
                    <QrCodeTemplateItem key={index} image_b64={qr.image_b64} device_id={qr.device_id} />
                ))}
            </Grid>
        </Box>

    );
};